export class QuotaLackTO {

    patientId: number;
    insuranceId: number;
    procedureId: number;
    companyId: number;
    performerId: number;
    specialityId: number;
    groupId: number;
    quantity: number;
    date: string;
    context: string;
}
